import React, { useState } from "react";
import { FreeSwitchDevelopersFaqs } from "../../../components/faqData.js";
import ContactUs from "../../../components/ContactUs.js";
import { Helmet } from "react-helmet-async";

const pointsData = [
  {
    title: "Replace Physical Presence",
    content:
      "We all lose potential clients when we can't reach the meeting location or primarily when we can't have a physical meeting. Audio-video conferencing solutions act as an escape in such a scenario where you can conduct meetings from any geographic location and be as effective as in person. This means the sky is the limit, and you can quickly grab lucrative opportunities in different locations.",
  },
  {
    title: "Efficient Communication",
    content:
      "With conferencing solutions, communication becomes much more efficient. It allows you to connect with your team or clients at any time without the need to be physically present.",
  },
  {
    title: "Ensure Participants Presence",
    content:
      "Conferencing solutions help ensure that all participants are present and engaged during the meeting by providing tools like attendance tracking, screen sharing, and real-time interaction.",
  },
  {
    title: "Consolidated Communication",
    content:
      "The use of conferencing solutions consolidates all forms of communication, allowing for seamless meetings without worrying about connectivity or location.",
  },
];

const Asterisk = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [actIndex, setActIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActIndex(index === actIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Get reliable Asterisk Development Services in India with custom VoIP solutions tailored to your business. Fast, secure & scalable communication starts here!"
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="Asterisk Development Services in India | Custom VoIP Solutions | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/asterisk"
        />
        <meta
          property="og:description"
          content="Get reliable Asterisk Development Services in India with custom VoIP solutions tailored to your business. Fast, secure & scalable communication starts here!"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="Asterisk Development Services in India | Custom VoIP Solutions | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="Get reliable Asterisk Development Services in India with custom VoIP solutions tailored to your business. Fast, secure & scalable communication starts here!"
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link rel="canonical" href="https://ayanshtechnology.com/asterisk" />
        <title>
          Asterisk Development Services in India | Custom VoIP Solutions |
          Ayanshtech Solutions
        </title>
      </Helmet>
      <div className=" flex flex-col items-center justify-center p-6">
        <div className=" p-4  w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16  ">
            <div className="lg:w-3/4 lg:text-left">
              <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                Asterisk Development Services in India
              </h2>

              <p className="sm:text-base md:text-lg lg:text-lg  mb-3">
                Asterisk is a leading open-source communication platform trusted
                by businesses worldwide for its flexibility and reliability.
                With our Asterisk Development Services in India, Ayanshtech
                Solutions helps organizations build robust, scalable, and
                cost-effective telephony systems tailored to their unique needs.
                Asterisk serves as the foundation for IP PBX systems, VoIP
                gateways, conferencing servers, and call center solutions,
                powering communication networks in over 170 countries. Our
                expert Asterisk developers specialize in creating customized
                solutions that enhance business communication and streamline
                operations. Whether you need a standalone PBX, a VoIP gateway,
                or integration between traditional TDM PBXs and modern IP-based
                systems, we deliver seamless and high-performance
                implementations.
              </p>

              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                We offer comprehensive Asterisk consulting and development
                services, including AGI scripting, IVR setup, CRM integration,
                and VoIP optimization. At Ayanshtech, our goal is to design
                efficient and affordable Asterisk-based solutions that deliver
                measurable business value. By leveraging our expertise, you can
                transform an ordinary computer into a powerful communication
                server and experience the full potential of Asterisk technology.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center  mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\headerSection\asterisk.webp"
                alt="Asterisk Development Services in India"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Asterisk Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Asterisk solutions offer versatile communication systems that can be
            tailored to suit various needs. These solutions include capabilities
            for conferencing, CRM integrations, and much more.
          </p>
        </div>

        <div className=" p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon1.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Monitoring</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon2.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Voicemail</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon3.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Transcoding</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Text-to-Speech</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Transfer</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Database Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Conference Bridging</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Automated Attendant</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Routing (DID & ANI)</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon19.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">ADSI On-Screen Menu Systems</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Waiting</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Recording</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Call Waiting</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Caller ID</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Our Asterisk Development Solutions
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Unlock the full potential of Asterisk solutions for an unparalleled
            customer experience beyond traditional PBX systems.
          </p>
        </div>

        <div className=" p-2">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\headerSection\Asterisk-image.png"
                alt="Laptop with graph"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon14.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Develop high-performance communication applications for
                    seamless integration.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon15.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Easily integrate with enterprise-level systems for maximum
                    efficiency.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon16.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Tailor the solution development process from scratch to meet
                    your specific needs.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon17.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Benefit from open-source capabilities that eliminate
                    licensing costs and expensive upgrades.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" rounded-3xl">
          <div className="text-center mb-5 mt-5">
            <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
              Asterisk-Based Solutions We Deliver
            </h2>
          </div>

          <div className=" p-8 ">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Item 1 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Contact Center Solutions</h3>
                <p className="text-lg">
                  Seamlessly integrate your call center operations with advanced
                  tools like CRM, conferencing, and communication platforms.
                </p>
              </div>

              {/* Item 2 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">Hosted PBX</h3>
                <p className="text-lg">
                  Build a reliable, scalable VOIP solution tailored for
                  single-tenant or multi-tenant environments with global
                  connectivity.
                </p>
              </div>

              {/* Item 3 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">IVR Solutions</h3>
                <p className="text-lg">
                  Enhance customer interaction with dynamic, user-friendly voice
                  response systems that streamline call workflows.
                </p>
              </div>

              {/* Item 4 */}
              <div
                className="relative flex flex-col space-y-4  rounded-lg p-6"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
                }}
              >
                <h3 className="text-lg font-bold">VoIP Gateway</h3>
                <p className="text-lg">
                  Leverage cost-effective, high-performance voice solutions
                  through virtual IP-based systems for seamless communication.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-green-50 p-6 sm:p-8 mb-12 sm:mb-16 rounded-3xl">
          {/* Title Section */}
          <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-6">
            Pain Points & Solutions
          </h2>

          {/* Navigation Bar */}
          <div className="flex justify-center flex-wrap gap-6 sm:gap-8 mb-4">
            {pointsData.map((point, index) => (
              <button
                key={index}
                className={`text-base sm:text-lg font-medium ${
                  activeIndex === index
                    ? "text-blue-600 underline"
                    : "text-gray-500"
                }`}
                onClick={() => setActiveIndex(index)}
              >
                {point.title}
              </button>
            ))}
          </div>

          {/* Content Section */}
          <div className="text-center max-w-5xl mx-auto p-4 border-gray-300">
            <p className="text-base sm:text-lg md:text-xl text-gray-600 mt-4">
              {pointsData[activeIndex].content}
            </p>
          </div>
        </div>

        <div className="p-6 sm:p-8 md:p-12 lg:p-16  w-full rounded-3xl">
          <div className="text-center mb-8">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Expert Asterisk Consulting and Support Solutions
            </h1>
          </div>

          <div className="mb-8 text-left">
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              At Ayanshtech, we offer professional Asterisk consulting and
              support services to help businesses implement and optimize their
              phone systems. Our team of skilled experts ensures your business
              leverages Asterisk to its fullest potential.
            </p>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Our key offerings include:
            </p>
            <ul className="list-disc pl-8 sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto">
              <li>Comprehensive installation and configuration services</li>
              <li>Tailored custom development solutions</li>
              <li>Seamless system integration</li>
              <li>Expert training sessions</li>
              <li>Reliable maintenance and ongoing support</li>
            </ul>
            <p className="sm:text-base md:text-lg lg:text-xl max-w-7xl mx-auto mb-4">
              Ayanshtech’s Asterisk specialists have deep expertise in the
              platform and its features. They provide actionable insights and
              recommendations to help you effectively meet your communication
              goals.
            </p>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="bg-blue-600 hover: hover:text-blue-600 hover:border hover:border-blue-600 hover:bg-white text-white font-semibold py-3 px-6 rounded-full text-lg transition duration-300"
            >
              Schedule a Free Consultation Today!
            </button>
          </div>
        </div>

        <div className="max-w-3xl mx-auto p-6 py-20 w-full ">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {FreeSwitchDevelopersFaqs.map((faq, index) => (
            <div key={index} className="border-b-2 border-blue-300">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  actIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {actIndex === index ? "-" : "+"}
                </span>
              </button>
              {actIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section">
          {" "}
          <ContactUs />
        </div>
      </div>
    </>
  );
};

export default Asterisk;
